module.exports = __webpack_public_path__ + "static/media/admin-image.b1f65430.svg";